__turbopack_context__.v({
  "closeButton": "style-module-scss-module__4hK1va__closeButton",
  "component": "style-module-scss-module__4hK1va__component",
});
